import MasterProvider from './routes/master_provider/MasterProvider.vue';
import createMasterProvider from './routes/master_provider/component/createMasterProvider.vue';
import editMasterProvider from './routes/master_provider/component/editMasterProvider.vue';

import PPOBProduct from './routes/ppob_product/PPOBProduct.vue';
import createPPOBProduct from './routes/ppob_product/component/createPPOBProduct.vue';
import editPPOBProduct from './routes/ppob_product/component/editPPOBProduct.vue';
import PPOBTransaction from './routes/ppob_transaction/PPOBTransaction.vue';

const PPOBRoutes = [
  {
    path: 'master-provider',
    name: 'MasterProvider',
    component: MasterProvider,
  },
  {
    path: 'create-master-provider',
    name: 'createMasterProvider',
    component: createMasterProvider,
  },
  {
    path: 'edit-master-provider/:id',
    name: 'editMasterProvider',
    component: editMasterProvider,
  },
  {
    path: 'ppob-product',
    name: 'PPOBProduct',
    component: PPOBProduct,
  },
  {
    path: 'create-ppob-product',
    name: 'createPPOBProduct',
    component: createPPOBProduct,
  },
  {
    path: 'edit-ppob-product/:id',
    name: 'editPPOBProduct',
    component: editPPOBProduct,
  },
  {
    path: 'ppob-transaction',
    name: 'PPOBTransaction',
    component: PPOBTransaction,
  },
];

export default PPOBRoutes;